import { createAction, createSlice } from "@reduxjs/toolkit";

export const deleteWorkflowRequest = createAction("workflowDelete/deleteWorkflowRequest");

const initialState = {
  response: null,
  loading: false,
  error: null
};

const workflowDeleteSlice = createSlice({
  name: "workflowDelete",
  initialState,
  reducers: {
    deleteWorkflowStart(state) {
      state.loading = true;
      state.error = null;
    },
    deleteWorkflowSuccess(state, action) {
      state.loading = false;
      state.response = action.payload || null;
      state.error = null;
    },
    deleteWorkflowFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    clearWorkflowDeleteState(state) {
      state.response = null;
      state.loading = false;
      state.error = null;
    }
  }
});

export const {
  deleteWorkflowStart,
  deleteWorkflowSuccess,
  deleteWorkflowFailure,
  clearWorkflowDeleteState
} = workflowDeleteSlice.actions;

export default workflowDeleteSlice.reducer;
